import React from 'react'
import { Route, Routes, Navigate } from 'react-router-dom'
import AppDetailsView from 'app/views/AppDetailsView'
import PageNotFound from 'app/components/PageNotFound'
import AppsList from 'app/views/AppsList'
import LoginView from 'app/views/LoginView'
import { EditForm } from 'app/views/AddApp/EditForm'
import { AddForm } from 'app/views/AddApp/AddForm'
import AddAPKView from 'app/views/AddAPKView'
import APKDetailsView from 'app/views/APKDetailsView'
import APKEditView from 'app/views/APKEditView'
import AppsCardsGrid from 'app/views/AppsCardsGrid'
import UserView from 'app/views/UserView'
import { APP_ROUTES } from './routes'
import { isTokenExpired } from 'app/utils/hooks'

const AppRouter = () => {
    return (
        <Routes>
            {isTokenExpired() && (
                <Route path={APP_ROUTES.ROOT} element={<AppsCardsGrid />} />
            )}
            {!isTokenExpired() && (
                <Route
                    path={APP_ROUTES.ROOT}
                    element={
                        <Navigate to={APP_ROUTES.VIEW_APPS_EDITOR} replace />
                    }
                />
            )}
            <Route path={APP_ROUTES.VIEW_APPS_EDITOR} element={<AppsList />} />
            <Route path={APP_ROUTES.ADD_APP} element={<AddForm />} />
            <Route path={APP_ROUTES.APP_DETAILS} element={<AppDetailsView />} />
            <Route path={APP_ROUTES.EDIT_APP} element={<EditForm />} />
            <Route path={APP_ROUTES.ADD_APK} element={<AddAPKView />} />
            <Route path={APP_ROUTES.VIEW_APK} element={<APKDetailsView />} />
            <Route path={APP_ROUTES.EDIT_APK} element={<APKEditView />} />
            <Route path={APP_ROUTES.LOGIN} element={<LoginView />} />
            <Route path={APP_ROUTES.USER_VIEW} element={<UserView />} />
            <Route path={APP_ROUTES.PAGE404_ERROR} element={<PageNotFound />} />
            <Route
                path={APP_ROUTES.PAGE_NOT_FOUND}
                element={<PageNotFound />}
            />
        </Routes>
    )
}

export default AppRouter
